import { loadWorkflows } from '../api/workflows';
import { useResourcesStore } from 'vince-core/stores/resourcesStore';
import { Action } from 'vince-core/types/roles';
import type { ResourceItem } from 'vince-core/types/common';

export default defineNuxtPlugin(() => {
    const store = useResourcesStore();
    store.registerResource('WORKFLOW', 'menus.workflows', [Action.WRITE, Action.READ], async () => {
        return await loadWorkflows().then((workflows) => {
            return workflows.map((it) => {
                return {
                    id: it.workflowId!,
                    key: it.workflowId!,
                    label: it.workflowAlias,
                    description: it.description,
                    resourceType: 'WORKFLOW',
                    usable: !it.hasError,
                    labels: it.labels ?? []
                } as ResourceItem;
            });
        });
    }, 'pi pi-workflows');
});
